export class ApiVersionModel {
  version?: string;

  constructor(data?: Partial<ApiVersionModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}